module.exports = __webpack_public_path__ + "img/logo-dark.3a985c8d.svg";